module.exports = __webpack_public_path__ + "media/images/icon__point--white-d5acd1318f0887750cbcaf4c446d34e4.png";